import { MedicalInformationCountByType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { MedicalDataSidePanelList } from './MedicalDataSidePanelList';
import { MedicalDataSidePanelListLoader } from './MedicalDataSidePanelList.loader';
import { dspatchUnsignedMedicalInformationAttachmentCountRefetchEvent } from './UnsignedMedicalInformationAttachmentBadge';

type MedicalDataSidePanelRegularContentProps = {
   readonly patientId: number;
   readonly activeMedicalDataItem: MedicalInformationCountByType;
   readonly onMedicalDataAccessAuthorizationUpdate: VoidFunction;
};

export const MedicalDataSidePanelRegularContent = (props: MedicalDataSidePanelRegularContentProps): JSX.Element => {
   return (
      <MedicalDataSidePanelListLoader
         patientId={props.patientId}
         medicalInformationType={props.activeMedicalDataItem.type}
      >
         {({ medicalInformation, refreshMedicalInformation }) => (
            <MedicalDataSidePanelList
               medicalInformation={medicalInformation}
               onMedicalDataAccessAuthorizationUpdate={() => {
                  refreshMedicalInformation();
                  props.onMedicalDataAccessAuthorizationUpdate();
                  dspatchUnsignedMedicalInformationAttachmentCountRefetchEvent({});
               }}
            />
         )}
      </MedicalDataSidePanelListLoader>
   );
};
